export default __webpack_public_path__ + "static/media/clock_icon_back.02d9df0d.svg";